import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const KrankschreibungPage = () => {
  return (
    <Layout>
      <PageHero
        title="Krankschreibungen & eAU: Unkompliziert und digital"
        subtitle="Ihre Krankmeldung wird direkt digital an die Krankenkasse übermittelt."
        backgroundImage="/images/Content_Behandlung_5.webp"
        ctaText="eAU jetzt nutzen"
      />

      <ContentSection
        title="Digitale Krankmeldung leicht gemacht"
        content="Mit der elektronischen Arbeitsunfähigkeitsbescheinigung (eAU) entfällt die Papierform. Nach der ärztlichen Feststellung Ihrer Arbeitsunfähigkeit wird die eAU automatisch an Ihre Krankenkasse übermittelt. Sie müssen sich um nichts weiter kümmern."
        image="/images/Content_Behandlung_5.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Digitale Krankschreibungen in Diez"
        content="Die Gemeinschaftspraxis Dres. von Bergh vereinfacht den Prozess Ihrer Krankschreibung durch die Nutzung der digitalen eAU, die direkt an Ihre Krankenkasse gesendet wird."
      />

      <CTASection
        title="Benötigen Sie eine Krankschreibung?"
        subtitle="Vereinbaren Sie einen Termin für eine Sprechstunde, um Ihre Arbeitsunfähigkeit feststellen zu lassen."
        buttonText="Online-Termin buchen"
      />
    </Layout>
  );
};

export default KrankschreibungPage;
